import { AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
// <!-- Note :  this page is used from PNI to Edge redirect only  to controll the api calls-->
@Component({
  selector: 'app-walktest-launch-page',
  templateUrl: './walktest-launch-page.html',
  styleUrls: ['./walktest-launch-page.scss']
})
export class WalktestLaunchPageComponent implements  OnInit, AfterViewInit,OnDestroy{
isSpinner:boolean;
token:any;
constructor(public router: Router,public service: AuthService,){
this.isSpinner=true;
  window.addEventListener("message", function (message) {
    console.log("token setttttt",message.data.token)
    if(message.data.token !=undefined && message.data.token !=null){  
      window.localStorage.setItem('token', message.data.token);
      console.log("token",message.data.token)
    }
  })


};
ngOnInit(): void {

}


ngAfterViewInit() {
  let token= localStorage.getItem('token');
  console.log("token",token)
  if(token){
    console.log("token if",token)
    // this.isSpinner=false;
    this.getUserDetails();
  }else{
    setTimeout(() => {
    console.log("token else",token)
    this.isSpinner=false;
    this.getUserDetails();
  }, 3000);
  }
}
getUserDetails(){
  let token= window.localStorage.getItem('token');
  if (token) {
    this.service.getUserDetails().subscribe((user: any) => {
      let profileid = user.result?._source?.user_type ? user.result?._source?.user_type : 'user';
      window.localStorage.setItem('full_name', user.result._source.fullname)
      this.service.getRoleDetails(profileid).subscribe((role: any) => {
        let roleRightsJson = role.result._source.pages;
        this.isSpinner = false;
        window.localStorage.setItem('sideMenuList', JSON.stringify(roleRightsJson));

        this.router.navigate(['/live-walk-test']);
      })
    },err=>{
      this.isSpinner = false;
      this.router.navigate(['/live-walk-test']);
    })
  }
}
ngOnDestroy() {
}

}
